/* Nationwide CareMatters New Jersey Insurance Application */
import { sharedSections } from './nationwideAppSharedSections';
import { sharedQuestions } from './nationwideAppSharedQuestions';
import { nationwideSharedDefs } from './nationwideSharedDefs';
import { nationwidePreApplicationFormDefinition } from '@shared/policy-application/nationwidePreApplicationFormDef';

export const nationwideCareMattersNJFormDefinition: PolicyFormDefinition = {
  requiredParameters: nationwideSharedDefs.requiredParameters,

  sections: [
    ...nationwidePreApplicationFormDefinition.sections,
    sharedSections.proposedInsured,
    sharedSections.proposedAdditionalInsured,
    sharedSections.policyOwner,
    sharedSections.jointOwner,
    sharedSections.contingentOwner,
    sharedSections.payor,
    sharedSections.beneficiary,
    sharedSections.premiumBilling,
    sharedSections.caremattersIIPlan,
    sharedSections.caremattersTogetherPlan,
    sharedSections.unintendedLapse,
    sharedSections.taxpayerCertification,
    sharedSections.electronicDelivery,
    sharedSections.insuranceInformation,
    sharedSections.insuranceInformationAdditional,
    sharedSections.insuranceInformationTable,
    sharedSections.financialInformation,
    sharedSections.specialInstructions,
    sharedSections.financialProfessional,
    sharedSections.formAcknowledgment,
    sharedSections.temporaryInsurance,
  ],

  questions: {
    ...nationwidePreApplicationFormDefinition.questions,
    ...sharedQuestions,
  },
}
